import type { HandlingUnitHashMap } from "@RequestFormV2/sections/PackingList/types";

export function buildHandlingUnitHashMap(
  handlingUnitOptions: Record<string, unknown>[] | undefined,
): HandlingUnitHashMap {
  if (!handlingUnitOptions?.length) return {};

  return handlingUnitOptions.reduce<HandlingUnitHashMap>((acc, item) => {
    const key = Object.keys(item)[0];
    if (key) {
      acc[key.toLowerCase()] = item[key] as HandlingUnitHashMap[string];
    }
    return acc;
  }, {});
}

export function hasContainerHandlingUnit(handlingUnitOptions: Record<string, unknown>[] | undefined) {
  return Boolean(handlingUnitOptions?.some((item) => Object.keys(item)[0] === "container"));
}
